import PhotoGallery from "./components/PhotoGallery";
import PropertyHeader from "./components/PropertyHeader";
import Highlights from "./components/Highlights";
import PropertyDetails from "./components/PropertyDetails";
import ContactPanel from "./components/ContactPanel";
import VideoAndMap from "./components/VideoAndMap";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Hero gallery — full width */}
      <div>
        <PhotoGallery />
      </div>

      {/* Property header with price */}
      <PropertyHeader />

      {/* Key highlights strip */}
      <Highlights />

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left: details + video/map */}
          <div className="flex-1 min-w-0">
            <PropertyDetails />
            <VideoAndMap />
          </div>

          {/* Right: contact sidebar */}
          <aside className="w-full lg:w-72 xl:w-80 flex-shrink-0">
            <div className="lg:sticky lg:top-24">
              <ContactPanel />
            </div>
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
}
